import React from 'react';
import jobReadyImage from '../assets/job.png'; // Using existing job image

const AIReadyJobProgram = () => {
  return (
    <div
      style={{
        padding: '40px',
        fontFamily: 'sans-serif',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        minHeight: '100vh',
        color: 'white',
      }}
    >
      {/* Heading + Image Row */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '20px',
        }}
      >
        {/* Left Section: Heading + Subheading + Small Container */}
        <div style={{ flex: '1', minWidth: '280px', marginLeft: '70px' }}>
          <h1 style={{ marginBottom: '10px', color: '#fff', fontSize: '42px', fontWeight: 'bold' }}>
          18-Month AI Job-Ready Program
          </h1>
          <p style={{ fontSize: '24px', color: '#E8F0FF', marginBottom: '20px' }}>
          Get Hired in AI Companies in Just 18 Months!
          </p>

          {/* Program Overview Container */}
          <div
            style={{
              padding: '25px',
              background: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '15px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
              maxWidth: '380px',
              marginTop: '10px',
              transition: 'all 0.4s ease',
              cursor: 'pointer',
              color: '#333',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 15px 50px rgba(0, 0, 0, 0.3)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 10px 40px rgba(0, 0, 0, 0.2)';
            }}
          >
            <h2 style={{ marginBottom: '15px', color: '#111', fontSize: '22px' }}>
              🎯 Fast-Track to AI Career
            </h2>
            <p style={{ color: '#111', fontSize: '16px', lineHeight: '1.6' }}>
            Perfect for those who want to enter the AI job market quickly. Learn GenAI, LLMs, Full-Stack + DSA in just 18 months with guaranteed job placement. Start earning ₹5-10 LPA!</p>
          </div>
        </div>

        {/* Right Section: Image */}
        <div style={{ flex: '0 0 500px', textAlign: 'center', marginLeft: '-10px' }}>
          <img
            src={jobReadyImage}
            alt="Job Ready"
            style={{
              width: '100%',
              maxWidth: '400px',
              height: '500px',
              objectFit: 'contain',
            }}
          />
        </div>
      </div>

      {/* Fast-Track Timeline */}
      <h2
        style={{
          marginTop: '60px',
          textAlign: 'center',
          color: '#fff',
          fontSize: '28px',
          marginBottom: '40px',
        }}
      >
        🚀 Fast-Track Learning Path
      </h2>

      {/* Container for Timeline */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '25px',
          flexWrap: 'wrap',
          marginTop: '30px',
        }}
      >
        {/* Phase 1 */}
        <div
          style={{
            flex: '1',
            maxWidth: '350px',
            height: '380px',
            padding: '25px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '15px',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.3s ease',
            backdropFilter: 'blur(10px)',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.2)';
          }}
        >
          <h3 style={{ marginBottom: '15px', color: '#FFD700', fontSize: '20px' }}>Months 1-6: Foundation & DSA</h3>
          <h4 style={{ fontSize: '16px', color: '#E8F0FF', marginBottom: '15px' }}>Programming + Problem Solving Master</h4>
          <ul style={{ color: '#fff', fontSize: '14px', lineHeight: '1.6' }}>
            <li>• Python/Java fundamentals & OOP</li>
            <li>• Data Structures & Algorithms (500+ problems)</li>
            <li>• System Design basics</li>
            <li>• Git, GitHub, and development tools</li>
            <li>• 2 major projects in portfolio</li>
            <li>• Mock interviews every week</li>
          </ul>
        </div>

        {/* Phase 2 */}
        <div
          style={{
            flex: '1',
            maxWidth: '350px',
            height: '380px',
            padding: '25px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '15px',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.3s ease',
            backdropFilter: 'blur(10px)',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.2)';
          }}
        >
          <h3 style={{ marginBottom: '15px', color: '#FF6B6B', fontSize: '20px' }}>Months 7-12: AI & Full-Stack</h3>
          <h4 style={{ fontSize: '16px', color: '#E8F0FF', marginBottom: '15px' }}>Cutting-edge AI Development Skills</h4>
          <ul style={{ color: '#fff', fontSize: '14px', lineHeight: '1.6' }}>
            <li>• GenAI & LLM development (OpenAI, Anthropic)</li>
            <li>• RAG systems & Vector Databases</li>
            <li>• MERN/MEAN Stack development</li>
            <li>• Machine Learning with Python</li>
            <li>• 5 AI-powered web applications</li>
            <li>• Cloud deployment (AWS/Vercel)</li>
          </ul>
        </div>

        {/* Phase 3 */}
        <div
          style={{
            flex: '1',
            maxWidth: '350px',
            height: '380px',
            padding: '25px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '15px',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.3s ease',
            backdropFilter: 'blur(10px)',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.2)';
          }}
        >
          <h3 style={{ marginBottom: '15px', color: '#4ECDC4', fontSize: '20px' }}>Months 13-18: Job Placement</h3>
          <h4 style={{ fontSize: '16px', color: '#E8F0FF', marginBottom: '15px' }}>Guaranteed job placement support</h4>
          <ul style={{ color: '#fff', fontSize: '14px', lineHeight: '1.6' }}>
            <li>• Advanced interview preparation</li>
            <li>• 1-on-1 mentorship with industry experts</li>
            <li>• Portfolio optimization & LinkedIn</li>
            <li>• Direct referrals to 50+ partner companies</li>
            <li>• Salary negotiation training</li>
            <li>• Job guarantee or money back</li>
          </ul>
        </div>
      </div>

      {/* Key Highlights */}
      <div style={{ marginTop: '80px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '28px', color: '#fff', marginBottom: '40px' }}>
          🌟 Why This Program Guarantees Success
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '30px',
          maxWidth: '1000px',
          margin: '0 auto',
        }}>
          {[
            {
              icon: '🤖',
              title: 'AI-First Curriculum',
              desc: 'Learn the exact AI skills that companies are hiring for in 2024-2025'
            },
            {
              icon: '💰',
              title: '₹5-10 LPA Guarantee',
              desc: 'Our graduates average ₹7.5 LPA starting salary with top AI companies'
            },
            {
              icon: '⚡',
              title: 'Fast-Track Learning',
              desc: '18 months intensive training = 3x faster than traditional programs'
            },
            {
              icon: '🎯',
              title: '100% Job Placement',
              desc: 'We don\'t get paid until you get hired. Your success is our success!'
            }
          ].map((item, index) => (
            <div key={index} style={{
              padding: '25px',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '15px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'transform 0.3s ease',
            }}>
              <div style={{ fontSize: '40px', marginBottom: '15px' }}>{item.icon}</div>
              <h3 style={{ color: '#FFD700', fontSize: '18px', marginBottom: '10px' }}>{item.title}</h3>
              <p style={{ color: '#E8F0FF', fontSize: '14px', lineHeight: '1.6' }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Investment & ROI */}
      <div style={{
        marginTop: '80px',
        padding: '40px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '20px',
        border: '2px solid rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(10px)',
        textAlign: 'center',
        maxWidth: '800px',
        margin: '80px auto 0',
      }}>
        <h2 style={{ fontSize: '28px', color: '#FFD700', marginBottom: '30px' }}>
          💎 Investment That Changes Your Life
        </h2>
        
        <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: '30px' }}>
          <div>
            <h3 style={{ color: '#FF6B6B', fontSize: '24px' }}>Total Investment</h3>
            <p style={{ color: '#fff', fontSize: '32px', fontWeight: 'bold' }}>₹18,000</p>
            <p style={{ color: '#E8F0FF', fontSize: '14px' }}>One-time payment</p>
          </div>
          <div>
            <h3 style={{ color: '#4ECDC4', fontSize: '24px' }}>Expected Salary</h3>
            <p style={{ color: '#fff', fontSize: '32px', fontWeight: 'bold' }}>₹5-10 LPA</p>
            <p style={{ color: '#E8F0FF', fontSize: '14px' }}>Starting package</p>
          </div>
          <div>
            <h3 style={{ color: '#FFD700', fontSize: '24px' }}>ROI</h3>
            <p style={{ color: '#fff', fontSize: '32px', fontWeight: 'bold' }}>5000%+</p>
            <p style={{ color: '#E8F0FF', fontSize: '14px' }}>Return on investment</p>
          </div>
        </div>
      </div>

      {/* Final CTA */}
      <div style={{ marginTop: '80px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '32px', color: '#fff', marginBottom: '15px' }}>
          🚀 Limited Time: Only 30 Seats Available!
        </h2>
        <p style={{ fontSize: '18px', color: '#E8F0FF', marginBottom: '30px', maxWidth: '600px', margin: '0 auto 30px' }}>
          Don't wait! Companies are desperately hiring AI developers. Secure your spot before it's too late.
        </p>
        
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            style={{
              padding: '18px 40px',
              fontSize: '20px',
              backgroundColor: '#FFD700',
              color: '#333',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              boxShadow: '0 8px 25px rgba(255, 215, 0, 0.4)',
              transition: 'all 0.3s ease',
              fontWeight: 'bold',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#FFC700';
              e.currentTarget.style.transform = 'translateY(-3px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FFD700';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            onClick={() => {
              window.open('https://forms.gle/VZfbRCurJkDGXdx7A', '_blank');
            }}
          >
            🎯 Claim Your Spot Now!
          </button>
        </div>
      </div>

      {/* Pricing & Enrollment Section */}
      <div style={{
        marginTop: '60px',
        padding: '50px',
        background: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '25px',
        boxShadow: '0 15px 50px rgba(0, 0, 0, 0.3)',
        textAlign: 'center',
        maxWidth: '900px',
        margin: '60px auto 40px',
        color: '#333',
      }}>
        <h2 style={{ fontSize: '36px', color: '#667eea', marginBottom: '15px', fontWeight: 'bold' }}>
          💎 Limited Time Offer
        </h2>
        <p style={{ fontSize: '18px', color: '#666', marginBottom: '30px' }}>
          Join the fastest-growing AI program in India!
        </p>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '25px',
          marginBottom: '25px',
          flexWrap: 'wrap',
        }}>
          <span style={{
            fontSize: '28px',
            color: '#999',
            textDecoration: 'line-through',
          }}>
            ₹25,000
          </span>
          <span style={{
            fontSize: '28px',
            color: '#ccc',
            textDecoration: 'line-through',
            display: 'block',
            marginBottom: '8px'
          }}>
            ₹40,000
          </span>
          <span style={{
            fontSize: '56px',
            color: '#667eea',
            fontWeight: 'bold',
          }}>
            ₹20,000
          </span>
          <span style={{
            background: 'linear-gradient(135deg, #FF6B6B, #FF8E53)',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '30px',
            fontSize: '18px',
            fontWeight: 'bold',
            boxShadow: '0 4px 15px rgba(255, 107, 107, 0.4)',
          }}>
            🔥 Save ₹5,000
          </span>
        </div>
        
        <p style={{ color: '#667eea', fontSize: '20px', marginBottom: '35px', fontWeight: '600' }}>
          18-Month Complete AI Training + Job Guarantee | Flexible EMI Available
        </p>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '20px',
          marginBottom: '40px',
        }}>
          <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', padding: '20px', borderRadius: '15px', color: '#fff' }}>
            <p style={{ fontSize: '18px', fontWeight: 'bold' }}>✅ GenAI & LLMs</p>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', padding: '20px', borderRadius: '15px', color: '#fff' }}>
            <p style={{ fontSize: '18px', fontWeight: 'bold' }}>✅ Full-Stack + DSA</p>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', padding: '20px', borderRadius: '15px', color: '#fff' }}>
            <p style={{ fontSize: '18px', fontWeight: 'bold' }}>✅ 100% Job Guarantee</p>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', padding: '20px', borderRadius: '15px', color: '#fff' }}>
            <p style={{ fontSize: '18px', fontWeight: 'bold' }}>✅ ₹5-10 LPA Package</p>
          </div>
        </div>
        
        {/* CTA Buttons */}
        <div style={{
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}>
          <button
            style={{
              padding: '18px 40px',
              fontSize: '20px',
              backgroundColor: '#667eea',
              color: '#fff',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)',
              transition: 'all 0.3s ease',
              fontWeight: 'bold',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#5568d3';
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#667eea';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
            }}
            onClick={() => {
              window.open('https://forms.gle/VZfbRCurJkDGXdx7A', '_blank');
            }}
          >
            🚀 Enroll Now
          </button>
          
          <button
            style={{
              padding: '18px 40px',
              fontSize: '20px',
              backgroundColor: 'transparent',
              color: '#667eea',
              border: '2px solid #667eea',
              borderRadius: '12px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontWeight: 'bold',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#667eea';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#667eea';
            }}
            onClick={() => {
              window.open('https://wa.me/919322346482?text=I want to know about the 18-Month AI Job-Ready Program', '_blank');
            }}
          >
            💬 Talk to Mentor
          </button>
        </div>
        
        <div style={{ marginTop: '30px' }}>
          <p style={{ color: '#FF6B6B', fontSize: '18px', fontWeight: 'bold' }}>
            ⏰ Batch starts in 1 week | Only 30 seats available
          </p>
          <p style={{ color: '#667eea', fontSize: '16px', marginTop: '10px' }}>
            💯 100% Job Guarantee or Full Refund
          </p>
        </div>
      </div>
    </div>
  );
};

export default AIReadyJobProgram;
